import { action } from 'src/redux/actions';
import { Breadcrumb } from 'src/routing/BreadcrumbWrapper';

export const RESOLVE_BREADCRUMBS = 'RESOLVE_BREADCRUMBS';
export const PUT_BREADCRUMBS = 'PUT_BREADCRUMBS';

export const resolveBreadcrumbs = (breadcrumbs: Breadcrumb[]) => action(RESOLVE_BREADCRUMBS, { breadcrumbs });
export const putBreadcrumbs = (breadcrumbs: Breadcrumb[]) => action(PUT_BREADCRUMBS, { breadcrumbs });
